import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import { Link, useParams, useNavigate } from "react-router-dom";
import useAxios from "axios-hooks";
import { useInView } from "react-intersection-observer";
import { useMediaQuery } from "react-responsive";

import { request } from "../../api";
import Api from "../../api";
import SeoBlock from "../../components/seo_block/SeoBlock";
import ShowVtrgContent from "../../vitrage/components/show/ShowVtrgContent";
import EditVtrgContent from "../../vitrage/components/edit/EditVtrgContent";
import { Button } from "../../components";
import { normalizedAuthorsList } from "../../utils";
import { OtherProjects } from "../../includes";

import styles from "./project.module.scss";

const ProjectSingle = ({ contact }) => {

  const isMobile = useMediaQuery({ query: '(max-width: 979px)' });

  const { ref, inView } = useInView({
    threshold: .99
  });

  const checkuser =
    typeof document.cookie.split(`user_is_allowed=`)[1] != "undefined" &&
    document.cookie.split(`user_is_allowed=`)[1].split(";")[0] === "true";
  const VtrgEditMode = checkuser && window.location.pathname.includes("/edit");

  let project_slug = window.location.pathname.includes("/edit")
    ? window.location.pathname.replace("/edit", "").match(/([^\/]*)\/*$/)[1]
    : window.location.pathname.match(/([^\/]*)\/*$/)[1];
  let project_path = Api.project.replace(":slug", project_slug);

  const [{ data }] = useAxios({ url: project_path });

  const project = data ? data.project : {};
  const next_project = data ? data.next : {};
  const seo = data ? data.seo : {};

  const vitrage = data ? data.vitrage : [];

  const headBgImg = project && project.headimage && ( project.headimage.origin ? project.headimage.origin.url : project.headimage.url);
  const mobileHeadImg = project?.headimage?.mobile_headimage?.url;

  const clr = project && project.headback && project.headback.headcolor ? project.headback.headcolor : (project && project.headdark ? "#fff" : "#000");

  const projectImageStyles = {
    backgroundImage: `url('${request}${isMobile && mobileHeadImg ? mobileHeadImg : headBgImg}')`,
    color: clr,
  };

  const nextProjectImg = next_project?.headimage?.url;
  const mobileNextProjectImg = next_project?.headimage?.mobile_headimage?.url;

  const nextProjectStyle = {
    backgroundImage: `url('${request}${(mobileNextProjectImg && isMobile) ? mobileNextProjectImg : nextProjectImg}')`
  };

  const navigate = useNavigate();

  const projectContent = VtrgEditMode ? (
    <EditVtrgContent
      content={vitrage}
      instanceTypeEl={"Project"}
      instanceIdEl={project && project.id}
    />
  ) : (
    <ShowVtrgContent content={vitrage} />
  );

  const progressBarRef = useRef();

  const disableScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  
    window.onscroll = function() {
        window.scrollTo(scrollLeft, scrollTop);
    };
  }

  const enableScroll = () => {
    window.onscroll = function() {};

    if (!isMobile) {
      progressBarRef.current.value = 0;
    }
  }

  useEffect(() => {
    function wheelHandler(event) {
      const SCROLL_STEP = 10;
      const isScrollDown = Math.round(event.deltaY) > 0;

      if (progressBarRef.current.value <= 0) {
        window.removeEventListener("wheel", wheelHandler);

        enableScroll();
      } else if (progressBarRef.current.value === 100) {
        navigate(`/projects/${data.next.slug}`);

        enableScroll();
      } else {
        if (isScrollDown) {
          progressBarRef.current.value += SCROLL_STEP;
        } else {
          progressBarRef.current.value -= SCROLL_STEP;
        }
      }
    }

    if (inView && progressBarRef.current) {
        progressBarRef.current.value = 1;

        window.addEventListener("wheel", wheelHandler);

        disableScroll();
      }

      return () => {
        window.removeEventListener("scroll", wheelHandler);
      }
  }, [inView, progressBarRef]);

  if (!data) {
    return null; // Сюда бы прелоадер пихнуть
  }

  return (
    <div className="project-page main-container-no-pdng">
      <SeoBlock data={seo} contact={contact} />

      <div className="shadow">
        <div style={projectImageStyles} className={classNames(styles.Header, isMobile && styles.HeaderMobile)}>
          <div
            className={classNames("wrap", styles.projectSingleTitleWrap)}
          >
            {project && project.title && (
              <h1 className={styles.projectSingleTitle}>{project.title}</h1>
            )}
          </div>
        </div>

        <div> {projectContent} </div>

        {project && project.siteurl && (
            <div className={styles.ProjectLinkWrapper}>
              <Button
                href={`${project.siteurl}`}
                target="_blank"
              >
                {project.siteurl.split("://")[1]
                    ? project.siteurl.split("://")[1]
                    : project.siteurl}
              </Button>
            </div>
          )}

        <div className="wrap holder">
          <div className="proj-team">
            {project.authors &&
              normalizedAuthorsList(project.authors).map((item, index) => {
                return (
                  <div className="proj-team-memb" key={index}>
                    <div
                      className="team-memb-post"
                      dangerouslySetInnerHTML={{ __html: item.role }}
                    ></div>
                    <ul className="team-memb-name">
                      {item.people.map((item) => (
                        <li
                          key={item}
                          dangerouslySetInnerHTML={{ __html: item }}
                        ></li>
                      ))}
                    </ul>
                  </div>
                );
              })}
          </div>
        </div>

        {data?.other_projects && (
        <>
          <div className="sharing-line"></div>

          <section className={styles.OtherProjects}>
            <div className="wrap holder no-pdn-top">
              <OtherProjects projects={data.other_projects} title="Другие проекты для этого клиента:" onClickButton={enableScroll} />
            </div>
          </section>
        </>
        )}

        {!isMobile && <progress className={styles.ProgressBar} ref={progressBarRef} max="100" min="0" value="0" />}
      </div>

      {(next_project?.slug && !VtrgEditMode) && (
        <Link
          onClick={!isMobile && enableScroll}
          to={`/projects/${next_project.slug}`}
          className={styles.nextProject}
          style={nextProjectStyle}
          ref={ref}
        >
          <div className={classNames("wrap holder", styles.nextProjectWrap)}>
            <div className={styles.nextProjectTitle}>
              {next_project.title}
            </div>

            {next_project.siteurl && next_project.siteurl.split("://")[1]
              ? next_project.siteurl.split("://")[1]
              : next_project.siteurl}
          </div>
        </Link>
      )} 
    </div>
  );
};

export default ProjectSingle;
